@import "../../../globals/scss/input";

:host {
  display: flex;
  height: $select-height;
  cursor: pointer;
  color: $color-gray;
}

:host(:not(.inside-dialog)) {
  border: $border-width solid $color-gray-tint-6;

  .component {
    .option {
      padding: 0 $select-inner-margin;
    }
  }
}

:host(:hover:not(.disabled):not(.inside-dialog)),
:host(.focus:not(.disabled):not(.inside-dialog)) {
  background-color: $color-horizon;
}

:host(.selected:not(.multiple):not(.inside-dialog)) {
  border-color: $color-int-blue;
  background-color: $color-int-blue;
  color: $color-white;
}

:host(.selected:not(.multiple):not(.inside-dialog):hover),
:host(.selected.focus:not(.multiple):not(.inside-dialog)) {
  border-color: $color-int-blue--active;
  background-color: $color-int-blue--active;
}

:host(:not(.multiple):not(.inside-dialog)) {
  label {
    padding-left: unset;

    &::before,
    &::after {
      display: none;
    }
  }
}

:host(.top) {
  border-top: none;
}

:host(.bottom) {
  border-bottom: none;
}

:host(.disabled) {
  cursor: not-allowed;
  color: $color-disabled;
}

.component {
  display: flex;
  flex: 1;
  white-space: nowrap;

  .option {
    flex: 1;
    display: flex;

    .input {
      flex: 1;
      display: flex;
      align-items: center;
    }
  }
}

:host(.sdx--dark-theme) {
  border-right-color: $color-int-blue2-dark-theme;
  border-left-color: $color-int-blue2-dark-theme;
  border-top-color: $color-gray-tint-7-dark-theme;
  border-bottom-color: $color-gray-tint-7-dark-theme;
  color: $color-gray-dark-theme;
}

:host(:hover:not(.disabled):not(.inside-dialog).sdx--dark-theme),
:host(.focus:not(.disabled):not(.inside-dialog).sdx--dark-theme) {
  background-color: $color-dusk-tint-3-dark-theme;
}

:host(.selected:not(.inside-dialog).sdx--dark-theme) {
  border-right-color: $color-int-blue2-dark-theme;
  border-left-color: $color-int-blue2-dark-theme;
  border-top: $color-int-blue2-dark-theme;
  border-bottom-color: $color-int-blue2-dark-theme;
  background-color: $color-int-blue-dark-theme;
}

:host(.selected:not(.inside-dialog).sdx--dark-theme:hover),
:host(.selected.focus:not(.inside-dialog).sdx--dark-theme) {
  border-right-color: $color-int-blue-dark-theme--active;
  border-left-color: $color-int-blue2-dark-theme--active;
  border-top-color: $color-int-blue2-dark-theme--active;
  border-bottom-color: $color-int-blue2-dark-theme--active;
  background-color: $color-int-blue-dark-theme--active;
}

:host(.disabled.sdx--dark-theme) {
  color: $color-disabled-dark-theme;
}
